export default function () {
  const widgetName = 'swiperWidget';
  const widgetOpts = swiperWidgetOpts;

  const swiperContainers = `
    <div class="swiper-container">
        <div class="swiper-wrapper">
        </div>
    </div>
  `;

  // Slide Template
  function buildSlideTemplate(slide) {
    const title = `<h2>${slide.Title.slice(0, 50)}</h2>`;
    const description = slide.Description ? `<p>${slide.Description}</p>` : '';

    const buttons = function (btn1) {
      if (btn1) {
        const btnContainer = $(`<a href="${btn1}" class="slider-button">
              <span class="slider-button__content">
                <span>More</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                  <path class="fa-secondary" opacity=".4" d="M338.7 224L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0 32-32-32-32z"/>
                  <path class="fa-primary" d="M438.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L370.7 256 233.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"/>
                </svg>
              </span>
            </a>`);
        return btnContainer.prop('outerHTML');
      } else {
        return '';
      }
    };
    const arrowLeft = `
    <div class="swiper-arrows__button swiper-arrows__button--prev" tabindex="0" role="button" aria-label="Previous slide">
      <span>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <path class="fa-secondary" opacity=".4"
            d="M338.7 224L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0 32-32-32-32z" />
          <path class="fa-primary"
            d="M438.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L370.7 256 233.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z" />
        </svg>
      </span>
    </div>`;
    
    const arrowRight = `
    <div class="swiper-arrows__button swiper-arrows__button--next" tabindex="0" role="button" aria-label="Next slide">
      <span>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <path class="fa-secondary" opacity=".4"
            d="M338.7 224L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0 32-32-32-32z" />
          <path class="fa-primary"
            d="M438.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L370.7 256 233.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z" />
        </svg>
      </span>
    </div>
    `;

    const template = `
    <div class="swiper-slide">
    <div role="region" class="swiper-image-container swiper-lazy" data-background="${
      slide.ImageWithPath
    }" aria-label="${slide.ImageAlternateText}">
      <div class="swiper-lazy-preloader"></div>
    </div>
    <div class="swiper-content-container">
      <div class="container">
        <div class="swiper-text"> 
          ${title}
          ${description}
        </div>
        <div class="swiper-navigators">
          ${arrowLeft}
          <div class="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets"></div>
          ${arrowRight}
        </div>
        <!-- end of swiper-navigators -->
      </div>
      <!-- end of container -->
    </div>
    <!-- end of swiper-content-container -->
    ${buttons(slide.URL)}
  </div>
  <!-- end of swiper-slide -->
    `;

    return template;
  }

  // Swiper Initialization
  function initSwiper(widgetData) {
    const swiperWidgetWrapper = $(`#${widgetName} .swiper-wrapper`);

    widgetData.forEach((slide, i) => {
      swiperWidgetWrapper.append(buildSlideTemplate(slide));
    });

    let autoplay = {
      delay: 6000,
    };

    let enableNav = {
      allowSlideNext: true,
    };

    function autoPlayCondition() {
      if (widgetData.length > 1) {
        return autoplay;
        return enableNav;
      } else {
        // class should be created. this can apply also for pagination
        return (autoplay = false);
        return (enableNav = false);
      }
    }

    const swiperWidget = new Swiper(`#${widgetName} .swiper-container`, {
      speed: 600,
      spaceBetween: 0,
      centeredSlides: false,
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      navigation: {
        nextEl: '.swiper-arrows__button--next',
        prevEl: '.swiper-arrows__button--prev',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      a11y: true,
      autoHeight: true,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoplay: false,
      allowSlideNext: autoPlayCondition(),
      allowSlidePrev: autoPlayCondition(),
    });
  }

  // Fetch data and initialize widget
  saffire.utils.getWidgetData(widgetOpts).then(function (response) {
    if (response.Slides.length > 0) {
      $(`#${widgetName}`).html(swiperContainers);
      initSwiper(response.Slides);
    } else {
      console.log(response);
      console.log('Error: No Data for swiperWidget');
    }
  });
}
